// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'wrap';

export const Component = () => (
  <>
    <path d='M14.706 10.477a.75.75 0 0 1 .75-.75h1v1.5h-1a.75.75 0 0 1-.75-.75zm1.75 7.75h-10v-1.5h10z' />
    <path d='M16.206 9.727h.25a4.25 4.25 0 0 1 0 8.5h-.25v-1.5h.25a2.75 2.75 0 0 0 0-5.5h-.25zm-10.28 8.281a.75.75 0 0 1 0-1.061L8.4 14.472l1.06 1.06-2.475 2.476a.75.75 0 0 1-1.06 0z' />
    <path d='M5.926 16.947a.75.75 0 0 1 1.06 0l2.475 2.475-1.06 1.06-2.475-2.474a.75.75 0 0 1 0-1.061zM6.5 13.5H4.8l3.272-9h1.952l3.276 9h-1.7L9.082 6.29h-.068zm.243-3.695h4.602v1.27H6.743z' />
  </>
);

export const viewBox = '0 0 25 25';
